import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HelpIndexComponent } from './helpIndex.component';

// internacionalization
import { TranslateModule } from '@ngx-translate/core';

import { FormsModule } from '@angular/forms';
import { HelpElementResultComponent } from './helpElementResult.component';
import { ContextHelpComponent } from './contextHelp.component';
import { GeneralHelpComponent } from './generalHelp.component';
import { DossierHeaderModule } from '../../../dossiers/components/dossierHeader.module';
import { WaitLoadingModule } from '../waitLoading/waitLoading.module';
import { HelpElementComponent } from './helpElement.component';
import { HelpAdminComponent } from './helpAdmin.component';
import { AccordionModule } from 'primeng-lts/accordion';
import { ButtonModule } from 'primeng-lts/button';
import { EditorModule } from 'primeng-lts/editor';
import { InputTextModule } from 'primeng-lts/inputtext';
import { ListboxModule } from 'primeng-lts/listbox';
import { OverlayPanelModule } from 'primeng-lts/overlaypanel';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';
import { TreeModule } from 'primeng-lts/tree';
import { TabViewModule } from 'primeng-lts/tabview';
import { DialogModule } from 'primeng-lts/dialog';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    HelpIndexComponent,
    HelpElementResultComponent,
    ContextHelpComponent,
    GeneralHelpComponent,
    HelpElementComponent,
    HelpAdminComponent
  ],
  imports: [
    TranslateModule,
    CommonModule,
    OverlayPanelModule,
    ButtonModule,
    TreeModule,
    ListboxModule,
    FormsModule,
    DossierHeaderModule,
    InputTextModule,
    DialogModule,
    WaitLoadingModule,
    EditorModule,
    AccordionModule,
    TabViewModule,
    EditorModule,
    ScrollPanelModule,
    RouterModule
  ],
  exports: [
    HelpIndexComponent,
    HelpElementResultComponent,
    ContextHelpComponent,
    GeneralHelpComponent,
    HelpElementComponent,
    HelpAdminComponent
  ], schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class HelpModule { }
